import { api } from "@api/api";
import { GenerateAgreementTokenResponse } from "./types";

export async function generateAgreementService(
  agreementId: string
): Promise<GenerateAgreementTokenResponse> {
  const { data: response } = await api.post<GenerateAgreementTokenResponse>(
    `v1/agreement_admin/${agreementId}/admin_create/`
  );

  return response;
}
